module.exports = __webpack_public_path__ + "static/media/edit.0873671b.svg";